import { createReducer } from 'redux-create-reducer'
import type { ClientLibrary } from 'types/client-library'
import {
  CLIENT_LIBRARY_DISCOVERY_PANEL_SET_LOAD,
  CLIENT_LIBRARY_DISCOVERY_PANEL_SET_LOAD_FAIL,
  CLIENT_LIBRARY_DISCOVERY_PANEL_SET_LOAD_SUCCESS,
} from '@disco/constants/ActionTypes'
export type State = {
  error: Error | null | undefined
  loading: boolean
  loaded: boolean
  items: ClientLibrary[]
}
const initialState: State = {
  error: null,
  loading: false,
  loaded: false,
  items: [],
}
export const discoveryPanelSetReducer = createReducer<State, any>(
  initialState,
  {
    [CLIENT_LIBRARY_DISCOVERY_PANEL_SET_LOAD](state: State) {
      return { ...state, error: null, loaded: false, loading: true }
    },

    [CLIENT_LIBRARY_DISCOVERY_PANEL_SET_LOAD_SUCCESS](
      state: State,
      { set }: Record<string, any>,
    ) {
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        items: set || state.items,
      }
    },

    [CLIENT_LIBRARY_DISCOVERY_PANEL_SET_LOAD_FAIL](
      state: State,
      { error }: Record<string, any>,
    ) {
      return { ...state, error, loaded: false, loading: false }
    },
  },
)
